const fa = {
  title: 'استعلام مشتری',
  loading: 'در حال بارگذاری…',
  logout: 'خروج',
  retry: 'تلاش دوباره',
  qrTitle: 'QR استعلام',
  qrHint: 'این صفحه را به مشتری نشان دهید؛ ورود به پنل لازم نیست.',
  qrCopy: 'کپی لینک',
  qrCopied: 'لینک کپی شد.',
  qrCopyFailed: 'کپی لینک انجام نشد. لینک را دستی کپی کنید.',
  menu: {
    section: 'استعلام',
    inquiry: 'استعلام مشتری',
    qr: 'QR استعلام',
  },
  status: {
    draft: 'پیش‌نویس',
    submitted: 'ثبت اولیه',
    inReview: 'در حال بررسی',
    needsCorrection: 'نیازمند اصلاح',
    corrected: 'اصلاح‌شده و آماده بررسی',
    approved: 'تأیید شده',
    rejected: 'رد شده',
  },
  actor: {
    customer: 'مشتری',
    admin: 'کارشناس',
    system: 'سامانه',
  },
  error: {
    generic: 'خطایی رخ داد. لطفاً دوباره تلاش کنید.',
    captchaLoad: 'بارگذاری تصویر امنیتی انجام نشد. دوباره تلاش کنید.',
    mobileInvalid: 'شماره موبایل باید ۱۱ رقم و با ۰۹ شروع شود.',
    captchaRequired: 'کد تصویر را وارد کنید.',
    codeRequired: 'کد پیامک را وارد کنید.',
    codeInvalid: 'کد تأیید باید حداقل ۴ رقم باشد.',
    required: 'این فیلد را پر کنید.',
    nationalId: 'کد ملی معتبر نیست.',
    birthDate: 'تاریخ تولد را به صورت سال/ماه/روز شمسی وارد کنید.',
    dueDate: 'تاریخ سررسید معتبر نیست.',
    landline: 'شماره تلفن ثابت معتبر نیست.',
    postal: 'کد پستی باید ۱۰ رقم باشد.',
    bankCode: 'بانک را از فهرست انتخاب کنید.',
    account: 'شماره حساب باید ۸ تا ۲۰ رقم باشد.',
    card: 'شماره کارت معتبر نیست.',
    iban: 'شماره شبا معتبر نیست.',
    ownsBank: 'تأیید کنید حساب، کارت و شبا به نام خودتان است.',
    idCardFront: 'تصویر روی کارت ملی را بارگذاری کنید.',
    idCardBack: 'تصویر پشت کارت ملی را بارگذاری کنید.',
    chequeRequired: 'حداقل یک فقره چک لازم است.',
    chequeLimit: 'حداکثر ۵۰ فقره چک در هر درخواست مجاز است.',
    sayad: 'شناسه صیادی باید ۱۶ رقم باشد.',
    sayadDuplicate: 'شناسه صیادی در این درخواست تکراری است.',
    chequeAmount: 'مبلغ چک باید بیشتر از صفر باشد.',
    chequeFront: 'تصویر روی چک الزامی است.',
    ownerIncomplete: 'اطلاعات صاحب چک را کامل کنید.',
    fileType: 'فقط تصویر JPEG، PNG یا WebP مجاز است.',
    fileSize: 'حجم فایل نباید بیشتر از ۲۰ مگابایت باشد.',
    loadForm: 'بارگذاری فرم انجام نشد. دوباره تلاش کنید.',
    loadPanel: 'بارگذاری درخواست‌ها انجام نشد. دوباره تلاش کنید.',
    loadDetail: 'بارگذاری جزئیات درخواست انجام نشد. دوباره تلاش کنید.',
  },
  otp: {
    title: 'ورود به استعلام',
    hint: 'شماره موبایل خود را وارد کنید تا کد تأیید برایتان پیامک شود.',
    mobile: 'شماره موبایل',
    mobilePlaceholder: '۰۹۱۲۳۴۵۶۷۸۹',
    captcha: 'کد تصویر',
    captchaPlaceholder: 'کد داخل تصویر',
    captchaRefresh: 'تصویر جدید',
    send: 'ارسال کد',
    resend: 'ارسال دوباره',
    resendWait: 'ارسال دوباره تا {seconds} ثانیه',
    code: 'کد پیامک',
    codePlaceholder: 'کد پیامک‌شده',
    verify: 'ورود',
    changeMobile: 'تغییر شماره',
  },
  placeholders: {
    newTitle: 'درخواست جدید',
    newBody: 'فرم استعلام در مرحلهٔ بعد آماده می‌شود.',
    panelBody: 'فهرست درخواست‌ها در مرحلهٔ بعد آماده می‌شود.',
    qrBody: 'صفحهٔ QR در مرحلهٔ بعد آماده می‌شود.',
    goPanel: 'رفتن به پنل',
    goNew: 'درخواست جدید',
    goHome: 'ورود به استعلام',
  },
  panel: {
    title: 'درخواست‌های من',
    newRequest: 'درخواست جدید',
    empty: 'هنوز درخواستی ثبت نکرده‌اید.',
    tracking: 'کد رهگیری',
    noTracking: 'هنوز ثبت نشده',
    noDate: '—',
    emptyValue: '—',
    status: 'وضعیت',
    updated: 'آخرین تغییر',
    submitted: 'تاریخ ارسال',
    open: 'مشاهده',
    continueDraft: 'ادامه پیش‌نویس',
    backToList: 'بازگشت به فهرست',
    detailTitle: 'جزئیات درخواست',
    adminComment: 'توضیح کارشناس',
    correctionHint: 'موارد زیر را کامل کنید و ذخیره کنید تا درخواست دوباره بررسی شود.',
    corrected: 'اصلاح شما ثبت شد و برای بررسی ارسال شد.',
    snapshot: 'اطلاعات ثبت‌شده',
    docs: 'مدارک',
    cheques: 'چک‌ها',
    events: 'تاریخچه',
    noFile: 'فایلی بارگذاری نشده',
    noCheques: 'چکی ثبت نشده',
    noEvents: 'رویدادی ثبت نشده',
    eventLine: '{actor} · از {from} به {to}',
    eventLineFirst: '{actor} · {to}',
    ownerSelf: 'صاحب چک خود متقاضی است',
    ownerThird: 'صاحب چک شخص ثالث',
    amountRial: '{amount} ریال',
    readOnlyHint: 'این درخواست فقط قابل مشاهده است.',
  },
  form: {
    title: 'فرم استعلام',
    hint: 'اطلاعات هویتی، بانکی، مدارک و چک‌ها را وارد کنید. می‌توانید پیش‌نویس را ذخیره کنید و بعداً ادامه دهید.',
    correctionHint: 'متن کارشناس را بخوانید، اطلاعات را اصلاح کنید و ذخیره کنید. همهٔ فیلدهای اجباری باید کامل باشند.',
    saved: 'پیش‌نویس ذخیره شد.',
    saveCorrection: 'ذخیره اصلاح',
    submitSuccessTitle: 'درخواست ثبت شد',
    submitSuccessHint: 'کد رهگیری را نگه دارید. از پنل می‌توانید وضعیت را ببینید.',
    trackingLabel: 'کد رهگیری',
    goPanel: 'مشاهده درخواست‌ها',
    saveDraft: 'ذخیره پیش‌نویس',
    submit: 'ارسال درخواست',
    closeToast: 'بستن اعلان',
    errorToastHint: 'برای مشاهدهٔ جزئیات به بالای فرم بروید.',
    errorsSummary: '{count} مورد نیاز به اصلاح دارد.',
    errorsSummaryHint: 'فیلدهای مشکل‌دار مشخص شده‌اند؛ موارد را تکمیل کنید.',
    identity: 'هویت و تماس',
    address: 'آدرس',
    bank: 'حساب بانکی',
    docs: 'مدارک شناسایی',
    cheques: 'چک‌ها',
    firstName: 'نام',
    lastName: 'نام خانوادگی',
    fatherName: 'نام پدر',
    nationalId: 'کد ملی',
    birthDate: 'تاریخ تولد',
    birthDateHint: 'مثال: ۱۳۷۰/۰۱/۱۵',
    mobile: 'شماره موبایل',
    phoneLandline: 'تلفن ثابت',
    province: 'استان',
    city: 'شهر',
    addressField: 'نشانی',
    postalCode: 'کد پستی',
    bankName: 'بانک',
    bankPlaceholder: 'انتخاب بانک',
    accountNumber: 'شماره حساب',
    cardNumber: 'شماره کارت',
    iban: 'شماره شبا',
    ownsBank: 'حساب، کارت و شبا به نام خودم است.',
    idCardFront: 'روی کارت ملی',
    idCardBack: 'پشت کارت ملی',
    shenasnameh: 'شناسنامه (اختیاری)',
    selfieWithId: 'سلفی با کارت ملی (اختیاری)',
    dropHint: 'تصویر را بکشید یا انتخاب کنید',
    dropReplace: 'برای جایگزینی، تصویر جدید انتخاب کنید',
    addCheque: 'افزودن چک',
    removeCheque: 'حذف این چک',
    chequeN: 'چک {n}',
    sayadId: 'شناسه صیادی',
    amount: 'مبلغ (ریال)',
    dueDate: 'سررسید',
    serial: 'سریال چک',
    chequeFront: 'روی چک',
    chequeBack: 'پشت چک (اختیاری)',
    ownerIsSelf: 'صاحب چک خودم هستم',
    ownerFirstName: 'نام صاحب چک',
    ownerLastName: 'نام خانوادگی صاحب چک',
    ownerNationalId: 'کد ملی صاحب چک',
    ownerFatherName: 'نام پدر صاحب چک',
    ownerMobile: 'موبایل صاحب چک',
    ownerRelationship: 'نسبت با متقاضی',
    ownerRelationshipNote: 'توضیح نسبت',
    relationship: {
      spouse: 'همسر',
      parent: 'پدر / مادر',
      child: 'فرزند',
      sibling: 'خواهر / برادر',
      other: 'سایر',
    },
  },
};

export default fa;
